import { render, staticRenderFns } from "./Details.modal.vue?vue&type=template&id=4db79cb2&scoped=true&"
import script from "./Details.modal.vue?vue&type=script&lang=js&"
export * from "./Details.modal.vue?vue&type=script&lang=js&"
import style0 from "./Details.modal.vue?vue&type=style&index=0&id=4db79cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db79cb2",
  null
  
)

export default component.exports